import script from "./LoaderGeneratorLog.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoaderGeneratorLog.vue?vue&type=script&lang=ts&setup=true"

import "./LoaderGeneratorLog.vue?vue&type=style&index=0&id=467be3d2&lang=css"

const __exports__ = script;

export default __exports__